module.exports = __webpack_public_path__ + "static/media/eyes-pwd.c01550c6.svg";